;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('MakePaymentController', MakePaymentController)

  MakePaymentController.$inject = [
    // Angular
    '$scope', '$uibModalInstance',

    // Managers
    'CreditNoteManager',

    // Services
    'UtilService', 'DatePickerService', 'PaginationModel', 'PreferencesService',

    // Resolve
    'creditNotes', 'payment',
    'balance', 'invoiceId', 'clientId', 'isUpdate'

  ]

  function MakePaymentController (
    // Angular
    $scope, $uibModalInstance,
    // Managers
    CreditNoteManager,
    // Services
    UtilService, DatePickerService, PaginationModel, PreferencesService,
    // Resolve
    creditNotes, payment,
    balance, invoiceId, clientId, isUpdate
  ) {
    const self = this
    let destroyed = false

    // Retire le watcher $rootScope de la pagination à la fermeture de la modale
    $scope.$on('$destroy', function () {
      destroyed = true
      if (self.creditNotePagination) self.creditNotePagination.destroy()
    })

    self.$onInit = () => {
      _.extend(self, {
        options: [
          { key: 'cash', value: 'Liquide' },
          { key: 'wire_transfert', value: 'Virement' },
          { key: 'check', value: 'Chèque' },
          { key: 'direct-debit', value: 'Prélèvement' },
          { key: 'credit-card', value: 'Carte bancaire' },
          { key: 'gift-card', value: 'Bon cadeau' }
        ],
        initAmount: initAmount,
        isFieldDisplayed: isFieldDisplayed,
        getInvoiceNumberFor: getInvoiceNumberFor,
        isCreditNotificationDisplayed: isCreditNotificationDisplayed,
        selectCreditNote: selectCreditNote,
        isAmountValid: isAmountValid,
        selectDate: selectDate,
        resetDate: resetDate,
        cancel: cancel,
        validate: validate,
        getCreditNotes: getCreditNotes,
        orderBy: orderBy,
        isUpdate: isUpdate,
        inited: false,
        maxPayment: -balance
      })
      init()
    }

    function init () {
      self.payment = payment || {}
      PaginationModel.get('crediNotesInvoicePagination', { perPage: 5 }).then(function (data) {
        // Modale déjà fermée avant la résolution : on retire tout de suite le watcher
        if (destroyed) return data.destroy()
        self.creditNotePagination = data
        self.creditNotePagination.orderBy = 'number'
        self.creditNotePagination.reverse = false
        getCreditNotes()
      })
      if (hasCreditNotes()) {
        self.options.push({ key: 'credit_note', value: 'Avoir' })
      }
      if (isUpdate) {
        self.selectedType = payment.type
        self.payment.date = new Date(payment.date)
      }
      self.inited = true
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        if (generalPrefs.settings.defaultPaymentType) {
          self.selectedType = generalPrefs.settings.defaultPaymentType
          initAmount()
        }
      })
    }

    function hasCreditNotes () {
      return !!creditNotes.data
    }

    function getCreditNotes () {
      CreditNoteManager.get(CreditNoteManager.query()
        .select(clientId, 'client')
        .select(['validated', 'sent', 'partly_paid'], 'status')
        .fields('_id number numberFormat date dueDate status balanceDue fullTotal lines payments')
        .sort(self.creditNotePagination.reverse ? '' : '-' + self.creditNotePagination.orderBy)
        .paginate(self.creditNotePagination.toQueryOptions())).then(data => {
        self.creditNotePagination.totalElements = data.meta.total
        self.creditNotes = data.data
      })
    }

    function orderBy (field) {
      if (self.creditNotePagination.orderBy === field) {
        self.creditNotePagination.reverse = !self.creditNotePagination.reverse
      } else {
        self.creditNotePagination.orderBy = field
        self.reverse = false
      }
      self.creditNotePagination.currentPage = 0
      getCreditNotes()
    }

    function selectDate () {
      DatePickerService.getRange(self.payment.date).then(function (date) {
        self.payment.date = new Date(date)
        self.paymentForm.$dirty = true
      })
    }

    function resetDate () {
      self.payment.date = null
      self.paymentForm.$dirty = true
    }

    function isCreditNotificationDisplayed () {
      return hasCreditNotes() && !(self.selectedType === 'credit_note')
    }

    function getInvoiceNumberFor (obj) {
      if (obj.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(obj, 'creditnote')
    }

    function isFieldDisplayed () {
      return self.hasOwnProperty('selectedType') &&
        (
          ['cash', 'wire_transfert', 'direct-debit', 'credit-card', 'check', 'gift-card'].includes(self.selectedType) ||
          self.payment.hasOwnProperty('ref')
        )
    }

    function getAmount () {
      return self.selectedCreditNote.balanceDue < balance ? -balance : -self.selectedCreditNote.balanceDue
    }

    function initAmount () {
      if (self.selectedType === 'credit_note' && self.hasOwnProperty('selectedCreditNote')) {
        self.payment = {
          date: new Date(),
          amount: {
            amount: getAmount(),
            currency: 'EUR'
          },
          type: 'credit_note',
          ref: {
            type: 'CreditNote',
            value: self.selectedCreditNote._id
          }
        }
      } else if (self.selectedType !== 'credit_note') {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref
        }
        if (self.hasOwnProperty('selectedCreditNote')) {
          delete self.selectedCreditNote
        }
        self.payment = {
          date: new Date(),
          amount: {
            amount: -balance,
            currency: 'EUR'
          },
          type: self.selectedType
        }
      } else {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref
        }
        if (self.hasOwnProperty('selectedCreditNote')) {
          delete self.selectedCreditNote
        }
      }
    }

    function selectCreditNote (index) {
      self.selectedCreditNote = self.creditNotes[index]
      self.initAmount()
    }

    function isAmountValid () {
      if (self.hasOwnProperty('selectedCreditNote')) {
        return -self.selectedCreditNote.balanceDue >= self.payment.amount.amount
      }
      return true
    }

    function validate () {
      self.payment.date = moment(moment(self.payment.date).startOf('d')).add(12, 'h')
      $uibModalInstance.close(self.payment)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }

})(window.angular, window._, window.moment)
